export default function (cli) {
  return {
    login (username, password, license) {
      cli.setToken(null)
      return cli.post(`${cli.apiEndpoint}auth/`)
        .send({ username, password, license })
    },
    tokenLogin (token) {
      return cli.post(`${cli.apiEndpoint}auth/token/`).send({ token })
    },
    verify (token) {
      return cli.post(`${cli.apiEndpoint}auth/verify/`).send({ token })
    },
    redirectToken () {
      return cli.get(`${cli.apiEndpoint}auth/redirect-token/`)
    },
  }
}



// WEBPACK FOOTER //
// ./src/api/auth.js